/** @jsxImportSource theme-ui */
import { Box, Heading } from 'theme-ui';
import { useParams } from 'react-router-dom';
import { JSONTree } from 'react-json-tree';
import { format } from 'date-fns';
import { useGetScheduledChangesQuery } from '@/store/apiService';
import DataTable from '@/components/DataTable';
import jsonTreeTheme from '@/theme/jsonTreeTheme';

const columns = [
    {
        columnKey: 'type',
        accessor: 'type',
        Header: 'Type',
    },
    {
        columnKey: 'status',
        accessor: 'status',
        Header: 'Type',
    },
    {
        columnKey: 'id',
        accessor: 'id',
        Header: 'Id',
        width: '100px',
        Cell: ({ row, cell }) => (
            <Box sx={{ width: '100px', whiteSpace: 'break-spaces' }}>{cell.value}</Box>
        ),
    },
    {
        columnKey: 'package',
        accessor: 'package',
        Header: 'Package',
        Cell: ({ row, cell }) => {
            return (
                <Box
                    sx={{
                        '& > ul': {
                            padding: (t: any) => `${t.space[2]} !important`,
                            borderRadius: (t: any) => `${t.radii['sm']} !important`,
                        },
                    }}
                >
                    <JSONTree
                        data={cell.value}
                        hideRoot={true}
                        theme={jsonTreeTheme}
                        invertTheme={true}
                        shouldExpandNodeInitially={(keyPath, data, level) => {
                            return true;
                        }}
                    />
                </Box>
            );
        },
    },
    {
        columnKey: 'tier',
        accessor: 'tier',
        Header: 'Tier',
        Cell: ({ row, cell }) => {
            return (
                <Box
                    sx={{
                        '& > ul': {
                            padding: (t: any) => `${t.space[2]} !important`,
                            borderRadius: (t: any) => `${t.radii['sm']} !important`,
                        },
                    }}
                >
                    <JSONTree
                        data={cell.value}
                        hideRoot={true}
                        theme={jsonTreeTheme}
                        invertTheme={true}
                        shouldExpandNodeInitially={(keyPath, data, level) => {
                            return true;
                        }}
                    />
                </Box>
            );
        },
    },
    {
        columnKey: 'plan',
        accessor: 'plan',
        Header: 'Plan',
        Cell: ({ row, cell }) => {
            return (
                <Box
                    sx={{
                        '& > ul': {
                            padding: (t: any) => `${t.space[2]} !important`,
                            borderRadius: (t: any) => `${t.radii['sm']} !important`,
                        },
                    }}
                >
                    <JSONTree
                        data={cell.value}
                        hideRoot={true}
                        theme={jsonTreeTheme}
                        invertTheme={true}
                        shouldExpandNodeInitially={(keyPath, data, level) => {
                            return true;
                        }}
                    />
                </Box>
            );
        },
    },
    {
        columnKey: 'scheduledDate',
        accessor: 'scheduledDate',
        Header: 'Scheduled date',
        Cell: ({ cell }) => {
            if (!cell.value) return '';
            return format(new Date(cell.value), 'd MMM yyyy, p');
        },
    },
];

const CompanyScheduledChanges = () => {
    const { id } = useParams();
    const scheduledChanges = useGetScheduledChangesQuery({ CompanyId: id });

    return (
        <Box>
            <Heading>Company subscription scheduled changes</Heading>
            <Box
                variant="segment"
                sx={{
                    borderRadius: 'sm',
                    overflowY: 'scroll',
                    zIndex: 2,
                    justifySelf: 'left',
                    width: '100%',
                    backgroundColor: 'background',
                    padding: 2,
                    position: 'relative',
                    table: {
                        display: 'block',
                        overflowX: 'auto',
                        whiteSpace: 'nowrap',
                    },
                    thead: {
                        textAlign: 'center',
                    },
                }}
            >
                <DataTable
                    data={scheduledChanges.data}
                    columns={columns}
                    isLoading={scheduledChanges.isLoading}
                    isFetching={scheduledChanges.isFetching}
                />
            </Box>
        </Box>
    );
};

export default CompanyScheduledChanges;
